export default "__VITE_ASSET__CcCc5a6w__"